const thirdPartyPath = "/asset/third-party/";
export const THIRD_PARTY_LOGOS = {
    NEXUS_MUTUAL_LIGHT: thirdPartyPath + "Nexus_Mutual_Logo_Landscape_Green_white.svg",
    NEXUS_MUTUAL_DARK: thirdPartyPath + "nexus-mutual-dark.svg",
    NEXUS_MUTUAL_LOGO: thirdPartyPath + "nexus-mutual-logo.svg",
} as const;
